import { CommunityCard } from "@/components/card/community";
import { PageHeader } from "@/components/layout/heading";
import { mCommunityCreatives } from "@/constants/community-assets";
import { createFileRoute } from "@tanstack/react-router";
import { useRef } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

export const Route = createFileRoute("/dashboard/_layout/community")({
  component: RouteComponent,
});

function RouteComponent() {
  const mGutterBreakpoints = { 300: 16 };
  const mColumnBreakpoints = { 300: 2, 600: 3, 900: 4 };
  const container$ = useRef<HTMLDivElement>(null!);

  return (
    <div ref={container$}>
      <PageHeader title="From the community" description="Explore the latest videos and images shared by our community" className="mb-8" />
      <div className="relative px-px lg:px-0">
        <ResponsiveMasonry columnsCountBreakPoints={mColumnBreakpoints} gutterBreakPoints={mGutterBreakpoints}>
          <Masonry>
            {mCommunityCreatives.map((creative, index) => {
              return <CommunityCard key={index} url={creative.url} type={creative.type} />;
            })}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </div>
  );
}
